/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useCallback } from "react";
import { Link } from "gatsby";
import { postAppMsg, platformCheck } from "gpages/utils/native_bridge";

const checkOnlyInApp = (to) => /^app:\/\//.test(to);

const Clickable = ({
  to,
  disabled,
  href,
  appNavTo,
  linkRef,
  newWindow = !checkOnlyInApp(appNavTo),
  ...restProps
}) => {
  const { onClick } = restProps;
  const handleAppNavToClick = useCallback(
    (e) => {
      if (!appNavTo) {
        return;
      }

      const onlyInApp = checkOnlyInApp(appNavTo);
      platformCheck(
        () => {
          // 机核 App 内通过事件跳转，stack navigator 推入新的 screen
          const link = appNavTo.startsWith("/")
            ? `${window.location.protocol}//${window.location.hostname}${appNavTo}`
            : appNavTo;
          postAppMsg("navigate", { link });
          e.preventDefault();
        },
        () => {
          // 其余浏览器默认行为：直接跳转
        },
        { onlyInApp },
      );
      if (onlyInApp) {
        e.preventDefault();
      }
      onClick?.(e);
    },
    [appNavTo, onClick],
  );

  const props = {
    ref: linkRef,
    ...restProps,
    ...(newWindow ? { target: "_blank" } : null),
  };

  if (disabled === true) {
    return <div {...props} />;
  }

  if (to) {
    return <Link to={to} {...props} />;
  }

  if (href) {
    return <a href={href} {...props} />;
  }

  if (appNavTo) {
    return <a href={appNavTo} {...props} onClick={handleAppNavToClick} />;
  }

  if (onClick) {
    return <a role="button" tabIndex={0} {...props} />;
  }

  return <div {...props} />;
};

export default Clickable;
